import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx } from "vue"

import { computed, reactive, watch, onMounted } from 'vue'
import { listStationBrief } from '@/api/operation'
import useI18nTl from '@/hooks/useI18nTl'
import { ElMessage } from 'element-plus'

import { defineComponent } from 'vue'
import { throttle } from 'lodash'

const __default__ = defineComponent({
  name: 'SelectStation',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  operatorID: {
    type: String,
    default: '0',
  },
  name: {
    type: String,
    default: '',
  },
  hasAllOptions: {
    type: Boolean,
    required: false,
    default: false,
  },
  isEssStation: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ['update:modelValue', 'submit', 'changes', 'change'],
  setup(__props, { emit }) {

const props = __props

const { t } = useI18nTl('Operation')



const selected = computed({
  get() {
    if (props.hasAllOptions && props.modelValue === '') {
      return '0'
    }
    return props.modelValue || ''
  },
  set(val) {
    emit('update:modelValue', val)
    console.log('select的set', val)
  },
})


const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      search: '',
      page: 1,
      limit: 10,
    },
  },
  stationList: [] as any[],
})
// watch(
//   () => props.modelValue,

//   (val) => {
// console.log('监听==', props.modelValue, props.name)
// if (props.modelValue != '0' && props.modelValue != '' && props.name != '') {
//   state.tableData.data.push({ id: props.modelValue, name: props.name })
// }
//   },
//   { immediate: true },
// )
watch(
  () => props.operatorID,
  (val) => {
    selected.value = ''
  },
  { deep: true },
)

// const _ = computed({
//     getTableData()
// })
const selectChange = (val: string) => {
  console.log('select', val)
  const find = state.stationList.find((item) => item.id === val)
  emit('change', find || {})
}
const beValueToList = () => {
  const list = state.stationList
  const find = list.find((item) => item.id === props.modelValue)
  if (!find && props.modelValue && props.modelValue != '0') {
    list.push({
      id: props.modelValue,
      name: props.name,
    })
  }
}

const getTableData = throttle((query = '') => {
  state.tableData.loading = true
  if (!state.tableData.loading) return
  listStationBrief({
    pageReq: {
      ...state.tableData.param,
      search: query,
    },
    operatorID: props.operatorID == '' ? '0' : props.operatorID,
    isEssStation: props.isEssStation,
    ID: props.modelValue || '0',
  })
    .then((res: any) => {
      const data = [] as any[]
      res.list.map((item: any) => {
        data.push({
          id: item.id,
          name: item.name,
        })
      })
      state.stationList = data || []
      state.tableData.data = data
      state.tableData.total = Number(res.pageReply.total_rows)
      state.tableData.loading = false // Set loading to false here
      beValueToList()
      if (state.stationList.length === 0) {
        // ElMessage.warning(t('Base.noData'))
      }
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
      state.tableData.loading = false // Set loading to false in case of error
    })
}, 500)

const onHandleSizeChange = (val: number) => {
  state.tableData.param.limit = val
  getTableData()
}

const onHandleCurrentChange = (val: number) => {
  state.tableData.param.page = val
  getTableData()
}
onMounted(() => {
  if (props.modelValue) {
    getTableData()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    "value-key": "id",
    size: "default",
    modelValue: _unref(selected),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
    filterable: "",
    remote: "",
    "remote-method": _unref(getTableData),
    disabled: __props.disabled,
    placeholder: _ctx.$t('Operation.selectStation'),
    onFocus: _cache[3] || (_cache[3] = ($event: any) => (_unref(getTableData)())),
    onChange: selectChange,
    clearable: ""
  }, {
    default: _withCtx(() => [
      (__props.hasAllOptions)
        ? (_openBlock(), _createBlock(_component_el_option, {
            key: 0,
            label: _ctx.$t('Dashboard.allStat'),
            value: '0'
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).stationList, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item.id,
          label: item.name,
          value: item.id
        }, null, 8, ["label", "value"]))
      }), 128)),
      _createVNode(_component_el_pagination, {
        onSizeChange: onHandleSizeChange,
        onCurrentChange: onHandleCurrentChange,
        "pager-count": 5,
        "page-sizes": [10, 20],
        "current-page": _unref(state).tableData.param.page,
        "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).tableData.param.page) = $event)),
        background: "",
        "page-size": _unref(state).tableData.param.limit,
        "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).tableData.param.limit) = $event)),
        small: "",
        layout: "prev, pager, next",
        total: _unref(state).tableData.total
      }, null, 8, ["current-page", "page-size", "total"])
    ]),
    _: 1
  }, 8, ["modelValue", "remote-method", "disabled", "placeholder"]))
}
}

})